import * as React from 'react'
import { Modal, Button } from 'react-bootstrap'
/*
    this class is the pop up page when you click on the button sign in
*/
interface ConnexionProps {
    ChangeViewToInscription: () => void
    ChangeViewToPasswordForgot: () => void
    updateEmail: (e: React.FormEvent<HTMLInputElement>) => void
    updatePassword: (e: React.FormEvent<HTMLInputElement>) => void
}

interface ConnexionState {
    EmailConnexion: string,
    PasswordConnexion: string,
}

export default class ConnexionModal extends React.Component<ConnexionProps, ConnexionState> {

    render() {
        return (
        <>
            <Modal.Body>
                <div className="form-group">
                    <b>Adresse e-mail</b>
                    <input className="form-control"
                        type="email"
                        placeholder="Entrer votre adresse e-mail" 
                        onInput={this.props.updateEmail}></input>
                </div>

                <div className="form-group">
                    <b>Mot de passe</b>
                    <input className="form-control"
                        type="password"
                        placeholder="Entrer votre mot de passe" 
                        onInput={this.props.updatePassword}></input>
                </div>

                <div className="form-group">
                    <Button variant="link"
                    onClick={this.props.ChangeViewToInscription}
                    ><u>Inscription</u></Button>

                    <Button variant="link"
                    onClick={this.props.ChangeViewToPasswordForgot}
                    ><u>Vous avez oublié votre mot de passe ?</u></Button>
                </div>
            </Modal.Body>
        </>
        );
    }

}